"use client";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import type { LanguageCode } from "@/types/i18n/types.ts";
export type Mode = "light" | "dark";

type State = {
  rootFontSize: number;
  formGap: number;
  mode: Mode;
  contained: boolean;
  language: LanguageCode;
};

const initialState: State = {
  rootFontSize: 16,
  formGap: 4,
  mode: "light",
  contained: true,
  language: "fr-FR",
};

export const preferencesSlice = createSlice({
  name: "preférences",
  initialState,
  reducers: {
    setRootFontSize: (state, action: PayloadAction<number>) => {
      state.rootFontSize = action.payload;
    },
    setMode: (state, action: PayloadAction<Mode>) => {
      state.mode = action.payload;
    },
    setContained: (state, action: PayloadAction<boolean>) => {
      state.contained = action.payload;
    },
    setLanguage: (state, action: PayloadAction<LanguageCode>) => {
      state.language = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
});

export const { setRootFontSize, setMode, setContained, setLanguage } =
  preferencesSlice.actions;
export default preferencesSlice.reducer;
